module.exports = __webpack_public_path__ + "static/media/pergunta.94b9cba3.svg";